import { changeUsername } from "#api/account/change-username";
import { FormRouter } from "#components/forms";
import { PageSkeleton } from "#components/pages";
import { ActionFunctionArgs, redirect } from "react-router";

export function AccountChangeUsernamePage() {
  const title = "Change Username";

  return (
    <PageSkeleton
      className="login-container"
      name="change-username"
      title={title}
      heading={title}
    >
      <FormRouter id="change_username_form" className="form" method="POST">
        <div className="form__section">
          <label className="form__label" htmlFor="username">Desired Username:</label>
          <input id="username" className="form__input form__input--username" type="text" name="username" />
        </div>

        <div className="form__section">
          <label className="form__label" htmlFor="password">Password:</label>
          <input id="password" className="form__input form__input--password" type="password" name="password" autoComplete="current-password" />
        </div>

        <div className="form__section">
          <button id="submit" className="form__button form__button--submit" type="submit">Change Username</button>
        </div>
      </FormRouter>
    </PageSkeleton>
  )
};

export async function action({ request }: ActionFunctionArgs) {
  if (request.method !== "POST") {
    throw new Error(`Unknown method ${request.method}.`);
  }

  const data = await request.formData();
  const username = data.get("username") as string || "";
  const password = data.get("password") as string || "";

  let result = await changeUsername(username, password);
  if (result === true) {
    return redirect("/account");
  }
}
